const config = {
    // basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs,
    // also don't put only '/' use blank('') instead
    basename: "",
    defaultPath: "/dashboard",
    fontFamily: `'Roboto', sans-serif`,
    borderRadius: 10,
};

export default config;
